import {
  Card as MuiCard,
  CardContent,
  makeStyles,
  withStyles,
} from '@material-ui/core';
import { AirportShuttle } from '@material-ui/icons';
import { GridShowLayout, RaGrid } from 'ra-compact-ui';
import React from 'react';
import {
  BooleanField,
  Datagrid,
  EditButton,
  FilterList,
  FilterListItem,
  FilterLiveSearch,
  List,
  ReferenceField,
  SelectField,
  Show,
  TextField,
  Toolbar,
} from 'react-admin';
import { getBommedExporter } from '../util/sheet';
import { Actions, Resources, useHasPermissions } from '../lib/react-admin-loopback';
import { FdAddressField } from '../common/components/FdAddressField';

const exporter = getBommedExporter('customer', {headers: ['id', 'name', 'displayName', 'address', 'managerName', 'managerTelNo', 'mobile', 'serviceType', 'serviceDay', 'salesMemo', 'invoiceBusinessNo', 'invoiceBusinessType', 'invoiceCustomerName', 'invoiceCeoName', 'invoiceEmail', 'paymentMethod', 'desc', 'taxInvoice']});

const PostShowActions = ({ basePath, data, resource }) => (
  <Toolbar
    classes={makeStyles({
      toolbar: {
        backgroundColor: 'inherit',
        margin: '0px',
      },
    })()}
  >
    <EditButton basePath={basePath} record={data} />
    {/* Add your custom actions */}
  </Toolbar>
);

const CustomerSimpleshow = (props) => {

  return (
    <Show
      {...props}
      title=' ' // disable the app title change when shown
      actions={props.hasEditPermission ? <PostShowActions /> : null}
    >
      <GridShowLayout>
        <RaGrid container spacing={3}>
          <RaGrid item xs={4}>
            <TextField source='mealMin' label='최소식수' />
          </RaGrid>
          <RaGrid item xs={4}>
            <ReferenceField
              link={false}
              source='curationGenderId'
              label='남녀구성비'
              reference='commonCodes'
            >
              <TextField source='desc' />
            </ReferenceField>
          </RaGrid>
          <RaGrid item xs={4}>
            <AgesField label='주요연령대' addLabel={true} />
          </RaGrid>
        </RaGrid>
        <RaGrid container spacing={3}>
          <RaGrid item xs={4}>
            <ReferenceField
              link={false}
              source='typeId'
              label='업종'
              reference='commonCodes'
            >
              <TextField source='desc' />
            </ReferenceField>
          </RaGrid>
          <RaGrid item xs={4}>
            <TextField source='salesTypeId' label='기업형태' />
          </RaGrid>
          <RaGrid item xs={4}>
            <TextField source='salesRevenue' label='월예상매출' />
          </RaGrid>
        </RaGrid>
        <RaGrid container spacing={3}>
          <RaGrid item xs={4}>
            <TextField source='managerTelNo' label='연락처' />
          </RaGrid>
          <RaGrid item xs={4}>
            <TextField source='mobile' label='핸드폰' />
          </RaGrid>
          <RaGrid item xs={4}>
            <TextField source='businessNo' label='사업자등록번호(고객사로그인)' />
          </RaGrid>
        </RaGrid>
        <RaGrid container spacing={3}>
          <RaGrid item xs={4}>
            <TextField source='salesManager' label='세일즈담당자' />
          </RaGrid>
          <RaGrid item xs={4}>
            <TextField source='salesStatusId' label='세일즈 상태' />
          </RaGrid>
        </RaGrid>
        <RaGrid container spacing={3}>
          <RaGrid item xs={4}>
            <TextField source='operationFee' label='운영비용(원)' />
          </RaGrid>
          <RaGrid item xs={4}>
            <BooleanField source='fixedBcs' label='고정 운영비 적용' />
          </RaGrid>
          <RaGrid item xs={4}>
            <TextField source='dcRate' label='할인율(%)' />
          </RaGrid>
        </RaGrid>
        <RaGrid container spacing={3}>
          <RaGrid item xs={4}>
            <TextField source='invoiceBusinessNo' label='사업자등록번호(세금계산서)' />
          </RaGrid>
          <RaGrid item xs={4}>
            <SelectField source='invoiceBusinessType' label="형태" choices={[
                    {id: 'simplified', name: '간이'},
                    {id: 'general', name: '일반'},
                    {id: 'corporate', name: '법인'}
            ]}/>
          </RaGrid>
          <RaGrid item xs={4}>
            <TextField source='invoiceCustomerName' label='상호명(세금계산서)' />
          </RaGrid>
        </RaGrid>
        <RaGrid container spacing={3}>
          <RaGrid item xs={4}>
            <TextField source='invoiceCeoName' label='대표자명(세금계산서)' />
          </RaGrid>
          <RaGrid item xs={4}>
            <TextField source='invoiceEmail' label='이메일(세금계산서)' />
          </RaGrid>
          <RaGrid item xs={4}>
            <ReferenceField
              link={false}
              source='paymentMethodId'
              label='결제수단'
              reference='commonCodes'
            >
              <TextField source='desc' />
            </ReferenceField>
          </RaGrid>
        </RaGrid>  
      </GridShowLayout>
    </Show>
  );
};

/// custom fields

const ServiceTypeField = ({ record = {} }) => {
  if (!record.serviceType) return '';
  if (record.serviceType.indexOf('//') != -1) {
    const cateArr = record.serviceType.split('//');
    const cateTxt = cateArr.join('<br><hr>');
    return <div dangerouslySetInnerHTML={{ __html: cateTxt }} />;
  } else {
    return <div>{record.serviceType}</div>;
  }
};

const ServiceTimeField = ({ record = {} }) => {
  if (!record.serviceTimeStr) return '';
  if (record.serviceTimeStr.indexOf('//') != -1) {
    const cateArr = record.serviceTimeStr.split('//');
    const cateTxt = cateArr.join('<br><hr>');
    return <div dangerouslySetInnerHTML={{ __html: cateTxt }} />;
  } else {
    return <div>{record.serviceTimeStr}</div>;
  }
};

const ServiceDayField = ({ record = {} }) => {
  if (!record.serviceDay) return '';
  if (record.serviceDay.indexOf('//') != -1) {
    const cateArr = record.serviceDay.split('//');
    const cateTxt = cateArr.join('<br><hr>');
    return <div dangerouslySetInnerHTML={{ __html: cateTxt }} />;
  } else {
    return <div>{record.serviceDay}</div>;
  }
};

const AgesField = ({ record = {} }) => {
  const value = record.curationAge ?? null;
  return (
    <span>
      {value != null && typeof value !== 'string'
        ? value.map((el) => el.desc).join('/')
        : value || ''}
    </span>
  );
};

/// filters

const ServiceFilter = () => (
  <FilterList label='서비스 여부' icon={<AirportShuttle />}>
    <FilterListItem
      label='서비스 중'
      value={{
        curation: true,
      }}
    />
    <FilterListItem
      label='해지'
      value={{
        curation: false,
      }}
    />
  </FilterList>
);

const Card = withStyles((theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      order: -1, // display on the left rather than on the right of the list
      width: '15em',
      marginRight: '1em',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}))(MuiCard);

const FilterSidebar = () => (
  <Card>
    <CardContent>
      <FilterLiveSearch source='name' />
      <ServiceFilter />
    </CardContent>
  </Card>
);

export const CustomerListV2 = (props) => {

  const hasReadPermission = useHasPermissions(
    Resources.Customer,
    Actions.Show,
  );

  const hasEditPermission = useHasPermissions(
    Resources.Customer,
    Actions.Edit,
  );

  return (
    <List
      {...props}
      aside={<FilterSidebar />}
      filterDefaultValues={{ curation: true }}
      bulkActionButtons={false}
      exporter={exporter}
    >
      <Datagrid 
        expand={
          hasReadPermission ? 
            <CustomerSimpleshow 
              hasEditPermission={hasReadPermission} // show edit button if has read permission 
            />
            : null
        }>
        <TextField source='id' />
        <TextField source='name' label='고객사' />
        {/* <TextField source='address' label='주소' /> */}
        <FdAddressField label="주소정보" />
        <ReferenceField
          link={false}
          source='deliveryGroupId'
          label='그룹'
          reference='commonCodes' >
          <TextField source='desc' />
        </ReferenceField>
        <TextField source='managerName' label='담당자' />
        <TextField source='managerEmail' label='이메일' />
        <ServiceTypeField label='서비스타입/비용' />
        <ServiceTimeField label='취식시간' />
        <ServiceDayField label='식사일' />
        <TextField source='mealAvg' label='평균취식인원' />
      </Datagrid>
    </List>
  );
};
